module.exports = __webpack_public_path__ + "img/lock-closed--white.4da6bdd0.svg";